import Head from "next/head";

export default function Seo({
  title = "Vanshi Tex | Wholesale Textile",
  description = "Explore premium textile products from Vanshi Tex.",
  canonical,
}) {
  return (
    <Head>
      <title>{title}</title>

      <meta name="description" content={description} />

      {canonical && <link rel="canonical" href={canonical} key="canonical" />}

      <meta name="robots" content="index, follow" />
    </Head>
  );
}
